import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Series from "../helpers/Series";


export default function SeriesCreate() {
    const { appState } = useAppState();
    const { register, handleSubmit } = useForm();
    const navigate = useNavigate()

    const onSubmit = handleSubmit((values) => {
        Series.create({
            name: values.name,
            variantType: values.variantType,
            variants: values.variantType ? true : false
        }).then(() => {
            navigate('/series')
        })
    });

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Categories \ New category</h1>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <form className="" onSubmit={onSubmit}>
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Details</h3>
                    <div className="flex flex-col gap-y-2">
                        <div className="flex flex-col">
                            <label>Name</label>
                            <input
                                className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                {...register('name')}
                                placeholder="Name"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label>Variant type</label>
                            <input
                                className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                {...register('variantType')}
                                placeholder="Variant type"
                            />
                        </div>
                    </div>
                    <div className="fixed bottom-0 left-0 right-0 z-40 p-6 border-t border-gray-100 bg-white/75">
                        <div className="flex gap-2 justify-end">
                            <Link
                                className="rounded-md bg-gray-500 px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                                to={`/series`}
                            >
                                Cancel
                            </Link>
                            <button
                                className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                type="submit"
                            >
                                Save
                            </button>
                        </div>

                    </div>
                </form>
            </div>
        </>
    );
}
